import { render } from "./News.vue?vue&type=template&id=25524df8&scoped=true&ts=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=25524df8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25524df8"]])

export default __exports__